import { slug } from "cuid";
import { Entry, EntryType } from "../types";

const mimeMap = new Map<string | boolean, EntryType>([
  ["application/epub+zip", EntryType.epub],
  ["application/msword", EntryType.doc],
  ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", EntryType.doc],
  ["application/pdf", EntryType.pdf],
  ["text/plain", EntryType.txt],
  [false, EntryType.unknown],
]);

export const convertEntry = (file: File): Entry => ({
  id: slug(),
  name: file.name,
  type: mimeMap.get(file.type) || EntryType.unknown,
  size: file.size,
  createdTime: new Date(file.lastModified).toUTCString(),
});
